import SaveServiciosDigitales from "../../shared/saveServiciosDigitales/SaveServiciosDigitales";

const CreateServiciosDigitales = ()=>{
  return(
    <SaveServiciosDigitales title="Crear Servicio Digital "/>
  )
}
export default CreateServiciosDigitales;